module.exports = __webpack_public_path__ + "img/hr-car-mask-2.1d0f6910.png";